// extracted by mini-css-extract-plugin
export default {"actionBubble":"actionBubble_actionBubble__mILMZ","actionBubbleIcon":"actionBubble_actionBubbleIcon__z3k7q","actionBubbleText":"actionBubble_actionBubbleText__ThXfU"};